import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const API_KEY = 'dk_29aca23f5e0bd8fdf9c9f';
const API_BASE_URL = 'https://api.supaserver.app';

const isProduction = () => {
  const hostname = window.location.hostname;
  return hostname === 'supaserver.app' || hostname === 'www.supaserver.app';
};

export function trackEvent(collection: string, data: Record<string, unknown>) {
  // В dev режиме только логируем в консоль
  if (!isProduction()) {
    console.log(`[trackEvent] ${collection}:`, data);
    return;
  }

  fetch(`${API_BASE_URL}/${collection}?apikey=${API_KEY}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).catch((e) => {
    console.error('Track event error:', e);
  });
} 